module.exports = __webpack_public_path__ + "fonts/iconfont.8048aa64.ttf";